import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { filterParams, PERIODS } from "@/lib/dateRange";

const VALID = new Set(PERIODS.map((p) => p.value));

/** Shared Date + Salesperson filters stored in the URL so drill-down links carry them. */
export function useFilters(defaultPeriod = "all") {
  const [params, setParams] = useSearchParams();
  const raw = params.get("period");
  const period = raw && VALID.has(raw) ? raw : defaultPeriod;
  const start = params.get("start") || "";
  const end = params.get("end") || "";
  const salesperson = params.get("salesperson") || "";

  const filters = useMemo(() => ({ period, start, end, salesperson }), [period, start, end, salesperson]);

  const setFilters = useCallback((patch) => {
    setParams((prev) => {
      const p = new URLSearchParams(prev);
      Object.entries(patch).forEach(([k, v]) => (v ? p.set(k, v) : p.delete(k)));
      return p;
    }, { replace: true });
  }, [setParams]);

  const apiParams = useMemo(() => filterParams(filters), [filters]);
  const query = useMemo(() => new URLSearchParams(apiParams).toString(), [apiParams]);

  return { filters, setFilters, apiParams, query, params, defaultPeriod };
}
